export const MIN_PASSWORD_LENGTH = 12;
export const MIN_EMAIL_LENGTH = 4;
export const RECOVERY_CODE_LENGTH = 6;
